import React from 'react';
import { withRouter, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import {
    customerEdit,
    getCustomer,
    updateCustomerTabContent,
    getBillingCards,
    resetBillingCards,
    setCustomerGridRefresh,
} from 'actions/customer';
import { createNewAppeal } from 'modules/appeal/actions';
import {
    openCustomerSpecModal,
    openCreateNewOrderModal,
    openCreateAppealFromFileModal,
} from 'actions/ui';
import {
    RouteWithTabs,
    isOrganization,
    isPartner,
    isServiceobjectType,
    checkBillingCards,
    extractCustomerFromState,
    getConfigTabs,
    getTabsWithPermissions,
    storedConfigTabs,
} from "helpers";
import Tab from 'components/Tab';
import TabContent from './TabContent/index';
import permissions, { checkPermissions } from 'config/permissions';
import tabsParams from 'constants/tabsParams';
import downloadCSV from 'actions/downloadCSV';
import { setTabName } from 'actions/tabs';
// import HistoryTab from '../HistoryTab/';
// import baseService from '../../services/BaseService';
// import { getLanguage } from '../../util/i18n';

const HIDE_SENSITIVE_TABS = false;

const SENSITIVE_TABS = [
    'billing_house',
    'billing_cards',
    'billing_finstatus',
    'billing_payments',
    'billing_recalculations',
];

const HISTORY_STATIC_SPACE_TO_EXTRACT = 19 + 43 + 36; // some extra padding + header filters + pagination;

function mapStateToProps(state, props) {
    const customer = extractCustomerFromState(state, props.match.params.id || props.id);
    // const {match: {
    //     params: { serviceId, appealId, orderId, resourceId, id },
    // }} = props;

    // const itemId = serviceId || appealId || orderId || resourceId;
    // const gridId = `${itemId}.${id}`;
    const gridId = state.grid && state.grid.gridKey;

    const accountNumbersCount =
        Array.isArray(state.customer.billingCards) && state.customer.billingCards.length;

    return {
        id: props.match.params.id || props.id,
        contactPersons: customer.contactPersons,
        pApartId: customer.currentCustomer && customer.currentCustomer.externalId,
        customerType: props.customerType || customer.currentCustomer.party.partyType,
        isCustomerManageContactPersons: checkPermissions(
            permissions.ContactPersonOperations.action_create_contactPerson,
        ),
        isViewAddress: checkPermissions(permissions.CustomerOperations.view_addresses),
        isEditAddress: checkPermissions(permissions.CustomerOperations.action_manageAddresses),
        isEditCustomer: checkPermissions(permissions.CustomerOperations.action_editCustomer),
        isCustomerCreationAllowed: checkPermissions(
            permissions.CustomerOperations.action_createCustomer,
        ),
        currentTab: state.tabs.current,
        isOrderCreate: checkPermissions(permissions.OrderOperations.action_createOrder),
        isOrderView: checkPermissions(permissions.CustomerOperations.view_Item),
        isServiceView: checkPermissions(permissions.ServiceOperations.view_service),
        isServiceCreate: checkPermissions(permissions.ServiceOperations.add_service),
        isResourceView: checkPermissions(permissions.ServiceOperations.view_resource),
        isResourceCreate: checkPermissions(permissions.ServiceOperations.add_resource),
        isBillingView: checkPermissions(permissions.BillOperations.view_BillInfo),
        isEventsView: checkPermissions(permissions.CalendarOperations.view_calendar_event),
        // gridSort: _.get(state, `grid[customer_appeals_${props.match.params.id || props.id}].params.sort`),
        grid: _.get(state.grid, gridId),
        // gridSort: _.get(state, `grid[customer_appeals_${gridId}].params.sort`),
        isContactsPersonView: checkPermissions(permissions.CustomerOperations.view_contactPersons),
        isCreateAppealFromExcel: checkPermissions(
            permissions.AppealOperations.action_createAppealGroupFromClient,
        ),
        accountNumbersCount,
        customerGridRefresh: state.customer.gridRefresh,
        isCustomerUpdating: customer.editing || customer.customerLoading
    };
}

const mapDispatchToProps = {
    customerEdit,
    getCustomer,
    createNewAppeal,
    openCustomerSpecModal,
    updateCustomerTabContent,
    setTabName,
    openCreateNewOrderModal,
    openCreateAppealFromFileModal,
    getBillingCards,
    resetBillingCards,
    setCustomerGridRefresh,
};

@withTranslation()
@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class MainContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configTabs: getTabsWithPermissions(storedConfigTabs(this.props.customerType)),
            historyHeightToExtract: 41 + HISTORY_STATIC_SPACE_TO_EXTRACT, // tabs height + pagination height + 
        };
        this.wait = false;
        this.tabsContainer = React.createRef();
    }

    componentDidMount() {
        const {
            currentTab,
            setTabName,
            customerName,
            isBillingView,
            pApartId,
            customerId,
            onConfigTabsReceive,
        } = this.props;
        const { configTabs } = this.state;
        if (!currentTab.displayedName) {
            setTabName(currentTab.name, customerName);
        }

        this.checkSensitiveTabs();


        if (!configTabs || configTabs.length === 0) {
            // this.getConfigTabs();
            const onSuccess = tabs => {
                if (onConfigTabsReceive && typeof onConfigTabsReceive === 'function') {
                    onConfigTabsReceive(tabs);
                }
                this.setState({ configTabs: tabs });
            }
            getConfigTabs({
                onSuccess,
                customerType: this.props.customerType,
                isBillingView,
                pApartId,
                customerId,
            });
        }

        // check if billing is inside of config;
        if (configTabs && configTabs.length > 0) {
            checkBillingCards(isBillingView, configTabs, pApartId, customerId);
        }
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    }

    componentDidUpdate(prevProps) {
        const {
            isBillingView,
            pApartId,
            getBillingCards,
            resetBillingCards,
            customerId,
            match,
            history
        } = this.props;

        

        if (prevProps.pApartId !== pApartId) {
            if (isBillingView) return getBillingCards(pApartId, customerId);

            return resetBillingCards();
        }

        const { configTabs} = this.state;
        const tabName = match.params.subTab;

        const isTabInConfig = configTabs && configTabs.find(tab => tab.code === tabName);
        if (!isTabInConfig) {
            const defaultTab = configTabs && configTabs[0] && configTabs[0].code;
            if (defaultTab) {
                history.push(defaultTab);
            }
        }
        this.checkSensitiveTabs();
        if (tabName !== prevProps.match.params.subTab) {
            this.handleResize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const tabsContainer = this.tabsContainer && this.tabsContainer.current;
        const tabName = this.props.match.params.subTab;
        if (tabsContainer && tabName === "history") {
            const { height } = tabsContainer.getBoundingClientRect();
            this.setState({ historyHeightToExtract: height + HISTORY_STATIC_SPACE_TO_EXTRACT });
        }
    }

    checkSensitiveTabs() {
        if (HIDE_SENSITIVE_TABS) {
            const params = this.props.match && this.props.match.params;
            if (params && params.subTab && SENSITIVE_TABS.includes(params.subTab)) {
                const path = this.props.history.location.pathname;
                let redirectTab = null;

                if (params.orderId) {
                    redirectTab = 'tasks';
                }

                if (params.serviceId) {
                    redirectTab = 'services';
                }

                if (!params.orderId && !params.serviceId) {
                    redirectTab = 'appeals';
                }

                if (redirectTab && this.props.history) {
                    const newPath = path.replace(/[^/]*$/, redirectTab);
                    this.props.history.push(newPath);
                }
            }
        }
    }

    render() {
        const {
            location,
            customerType,
            customerTypeId,
            match,
            id,
            customerId,
            accountNumbersCount,
            match: {
                url,
                params: { serviceId, appealId, orderId, resourceId, documentId },
            },
            customerGridRefresh,
            setCustomerGridRefresh,
            openAddressModal,
            pApartId,
        } = this.props;
        const tabName = match.params.subTab;
        const { configTabs } = this.state;

        const activeTab = configTabs.find((tab) => tab.code === tabName);
        const itemId = serviceId || appealId || orderId || resourceId || documentId;
        const path = url.split("/");
        const itemIdIndex = path.findIndex(item => +item === +itemId);
        const itemType = itemIdIndex ? path[itemIdIndex - 1] : "";

        const defaultTab = configTabs && configTabs[0] && configTabs[0].code;
        // if no tabName and defaultTab available from configTabs
        if (!tabName && defaultTab) {
            const newPath = location.pathname.endsWith('/')
                ? `${location.pathname}${defaultTab}`
                : `${location.pathname}/${defaultTab}`;
            return <Redirect to={newPath} />;
        }

        return (
            <main className='customerContent'>
                <div className="contentWrapper">
                    <div id="card-bottom-row" className="column customerContentTabs" ref={this.tabsContainer}>
                        <div className="top-right-overflow">
                            {configTabs.map((tab) => {
                                if (tab.code === 'billing_cards' && accountNumbersCount > 0)
                                    return (
                                        <Tab
                                            val={tab.code}
                                            key={tab.code}
                                            tab={tab.code}
                                            counter={`(${accountNumbersCount})`}
                                        />
                                    );
                                return (
                                    <Tab
                                        val={tab.code}
                                        tab={tab.code}
                                        name={tab.name}
                                        key={tab.code}
                                    />
                                );
                            })}
                        </div>
                    </div>
                    {activeTab && (
                        <TabContent
                            config={activeTab}
                            id={id}
                            itemId={itemId}
                            itemType={itemType}
                            customerGridRefresh={customerGridRefresh}
                            setCustomerGridRefresh={setCustomerGridRefresh}
                            openAddressModal={openAddressModal}
                            pApartId={pApartId}
                            customerId={customerId}
                            customerType={customerType}
                            customerTypeId={customerTypeId}
                            historyHeightToExtract={this.state.historyHeightToExtract}
                            key={tabName}
                        />
                    )}
                </div>
            </main>
        );
    }
}

MainContent.propTypes = {
    // ownProps
    customer: PropTypes.object,
    tabsNames: PropTypes.object,
    customerName: PropTypes.string,
    customerType: PropTypes.string,
    customerId: PropTypes.number,
    customerPatronymic: PropTypes.string,
    customerFirstName: PropTypes.string,
    customerLastName: PropTypes.string,
    // from connect mapDispatchToProps
    customerEdit: PropTypes.func,
    getCustomer: PropTypes.func,
    openGridPopUp: PropTypes.func,
};
